import api from "./api";

const fineService = {
    // List fines with filters
    getAll: (params = {}) => api.get("/fines", { params }),

    // Issue fine to single student
    issueSingle: (data) => api.post("/fines/single", data),

    // Issue fine in bulk to class/course/year/all
    issueBulk: (data) => api.post("/fines/bulk", data),

    // Waive a fine with justification
    waiveFine: (id, waiverReason) => api.put(`/fines/${id}/waive`, { waiverReason }),

    // Pay / settle a fine directly
    payFine: (id, paymentData = {}) => api.post(`/fines/${id}/pay`, paymentData),

    // Get fines for a specific student
    getByStudent: (studentId, params = {}) => api.get(`/fines/student/${studentId}`, { params }),

    // Delete a fine
    delete: (id) => api.delete(`/fines/${id}`),
};

export default fineService;
